import { lazy } from 'react';
import GuestGuard from 'utils/route-guard/GuestGuard';
import CommonLayout from 'layout/CommonLayout';
import Loadable from 'components/Loadable';

const AuthLogin = Loadable(lazy(() => import('pages/auth/auth1/login')));
const AuthRegister = Loadable(lazy(() => import('pages/auth/auth1/register')));
const AuthForgotPassword = Loadable(lazy(() => import('pages/auth/auth1/forgot-password')));
const AuthCheckMail = Loadable(lazy(() => import('pages/auth/auth1/check-mail')));
const AuthResetPassword = Loadable(lazy(() => import('pages/auth/auth1/reset-password')));
const PasswordExpiry = Loadable(lazy(() => import('pages/auth/auth1/password-expiry')));
const AuthCodeVerification = Loadable(lazy(() => import('pages/auth/auth1/code-verification')));
const PdfViewer = Loadable(lazy(() => import('pages/auth/auth1/pdf-viewer')));
const PrivacyPolicy = Loadable(lazy(() => import('pages/auth/auth1/privacy-policy')));

const LoginRoutes = () => {
  return [
    {
      path: '/',
      element: (
        <GuestGuard>
          <CommonLayout />
        </GuestGuard>
      ),
      children: [
        {
          path: 'login',
          element: <AuthLogin />
        },
        {
          path: 'register',
          element: <AuthRegister />
        },
        {
          path: 'forgot-password',
          element: <AuthForgotPassword />
        },
        {
          path: 'check-mail',
          element: <AuthCheckMail />
        },
        {
          path: 'reset-password',
          element: <AuthResetPassword />
        },
        {
          path: 'password-expiry',
          element: <PasswordExpiry />
        },
        {
          path: 'code-verification',
          element: <AuthCodeVerification />
        },
        {
          path: 'termsConditions',
          element: <PdfViewer />
        },
        {
          path: 'privacyPolicy',
          element: <PrivacyPolicy />
        }
      ]
    }
  ];
};

export default LoginRoutes;
